import * as actionTypes from '../actionTypes';

const state = {
  eventKey: '',
  eventName: '',
  eventProjectId: '',
  eventStartDateTime: '',
  eventEndDateTime: '',
  eventTimeZone: '',
  eventLocation: '',
  eventHealthyFormIsActive: false,
  eventSendMode: '',
  eventCheckinIdPrefix: '',
  eventFounder: '',
  eventBeginAt: null,
  eventEndAt: null,
  eventBannerUri: '',
  eventDescription: '',
  isEventActive: false,
  isEventSignUpEnabled: false,
  eventSignUpBannerUri: '',
  eventHomePageUuid: '',
};

function eventReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SWITCH_EVENT: {
      const eventInfo = action.data;

      if (!eventInfo) return state;
      if (Object.keys(eventInfo)?.length === 0) return state;

      return {
        ...globalState,
        ...eventInfo,
        isEventActive: eventInfo.isActive,
        isEventSignUpEnabled: eventInfo.isSignUpEnabled,
        eventSignUpBannerUri: eventInfo.signUpBannerUri,
        eventBannerUri: eventInfo.bannerUri,
        eventHomePageUuid: eventInfo.uuid,
        eventDescription: eventInfo.description,
        eventKey: eventInfo.key,
        eventName: eventInfo.name,
        eventFounder: eventInfo.founder,
        eventProjectId: eventInfo.projectId,
        eventStartDateTime: eventInfo.beginAt,
        eventEndDateTime: eventInfo.endAt,
        eventBeginAt: eventInfo.beginAt,
        eventEndAt: eventInfo.endAt,
        eventTimeZone: eventInfo.timeZone,
        eventLocation: eventInfo.location,
        eventHealthyFormIsActive: eventInfo.healthyFormIsActive,
        eventSendMode: eventInfo.sendMode,
        eventCheckinIdPrefix: eventInfo.checkinIdPrefix,
      };
    }
    default:
      return globalState;
  }
}

export { eventReducer as default };
